import { createContext, useContext } from 'react'
import type { SubsStoreState } from '@/msgdeskRuntime/state'

interface SubsContextType {
  state: SubsStoreState
  actions: {
    removeSub: (elId: number) => void
  }
}

export const SubsContext = createContext<SubsContextType | null>(null)

export function useSubsStore() {
  const ctx = useContext(SubsContext)
  if (!ctx) {
    throw new Error('useSubsStore must be used within a <SubsManager> provider.')
  }
  return ctx
}
